import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Box, Container, Typography, Slide } from '@mui/material';
import { CtaButton } from './ctaButton';
export const StickyCtaFooter = ({ ctaHref = '/scoring', onCtaClick, }) => {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            // Show footer after scrolling down 300px
            setVisible(window.scrollY > 300);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    return (_jsx(Slide, { direction: "up", in: visible, mountOnEnter: true, unmountOnExit: true, children: _jsx(Box, { sx: {
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1000,
                backgroundColor: '#111b2d',
                color: '#ffffff',
                boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.15)',
                py: { xs: 3, md: 4 },
            }, children: _jsx(Container, { maxWidth: "lg", sx: { px: { xs: 4, md: 6 } }, children: _jsxs(Box, { sx: {
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: { xs: 3, md: 4 },
                    }, children: [_jsxs(Box, { sx: { textAlign: { xs: 'center', md: 'left' } }, children: [_jsx(Typography, { variant: "h5", sx: {
                                        fontWeight: 700,
                                        mb: { xs: 0.5, md: 1 },
                                        fontSize: { xs: '15px', sm: '18px', md: '24px' },
                                        color: '#ffffff',
                                        lineHeight: 1.3,
                                    }, children: "Ready to Stop Wasting Hours on Resume Screening?" }), _jsx(Typography, { variant: "body2", sx: {
                                        fontSize: { xs: '12px', sm: '14px', md: '16px' },
                                        color: 'rgba(255, 255, 255, 0.85)',
                                        lineHeight: 1.4,
                                        display: { xs: 'none', sm: 'block' },
                                    }, children: "Get your Top 5 candidates in 2 minutes\u2014free trial, no credit card required" })] }), _jsx(CtaButton, { href: onCtaClick ? undefined : ctaHref, onClick: onCtaClick, size: "large", variant: "secondary", sx: {
                                flexShrink: 0,
                                minWidth: { xs: '100%', sm: 'auto', md: '200px' },
                                py: { xs: 2, md: 3 },
                                fontSize: { xs: '14px', md: '16px' },
                            }, children: "Start Free Trial" })] }) }) }) }));
};
